import { OFFER_CHANNEL, PRODUCT_FAMILY } from '@belong/types';
import { OFFER_CHANNEL_ACTION, OFFER_TYPE } from '@belong/types/api/offers';
import { IActivationOffersRequest, IAtlOffersRequest, IChangePlanOffersRequest } from './types';

export function createAtlOffersRequest(productFamily: PRODUCT_FAMILY, gainingPlans: string[]): IAtlOffersRequest {
  return {
    order: {
      gainingPlans,
      channels: [OFFER_CHANNEL.DIGITAL]
    },
    offerType: OFFER_TYPE.CHANNEL,
    productFamily
  };
}

export function createActivationOffersRequest(
  productFamily: PRODUCT_FAMILY,
  gainingPlans: string[],
  isPortIn?: boolean,
  simNumber?: string
): IActivationOffersRequest {
  return {
    customer: {
      offers: []
    },
    order: {
      gainingPlans,
      sim: simNumber,
      portIn: isPortIn,
      channels: [OFFER_CHANNEL.DIGITAL]
    },
    channelAction: OFFER_CHANNEL_ACTION.ACTIVATION,
    offerType: OFFER_TYPE.CHANNEL,
    productFamily
  };
}

export function createChangePlanOffersRequest(
  productFamily: PRODUCT_FAMILY,
  serviceId: string,
  gainingPlans: string[],
  losingPlan: string,
  currentPlanOffers?: string[]
): IChangePlanOffersRequest {
  return {
    customer: {
      offers: currentPlanOffers ?? [],
      serviceId
    },
    order: {
      channels: [OFFER_CHANNEL.DIGITAL],
      gainingPlans,
      losingPlan
    },
    channelAction: OFFER_CHANNEL_ACTION.POST_ACTIVATION,
    offerType: OFFER_TYPE.CHANNEL,
    productFamily
  };
}
